module.exports = __webpack_public_path__ + "fa-regular-400.b0e2db3b634d1bc3928e.eot";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-regular-400.eot
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-regular-400.eot
// module chunks = 2